import mixitup from 'mixitup';

(function ($) {
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-8 py-4"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').on('click', function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').on('click', function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  // Desktop nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').on('hover', function () {
    if ($(window).innerWidth() > 991) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element) {
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });

  $(window).scroll(function() {

    if ($(document).scrollTop() > 1000) {
      // Trigger this event when scrolled below pixels
      $('.bg-navmenu').addClass('scrolled');
      $('#fox-logo-full').attr("src" , "/app/uploads/2024/05/Fox_Windows_logo-transparent-1.png");
      $('#fox-logo-full').attr("srcset" , "/app/uploads/2024/05/Fox_Windows_logo-transparent-1.png 1x, /app/uploads/2024/05/Fox_Windows_logo-transparent-1.png 2x");
      $('.bg-navmenu .nav-primary ul li a').addClass('scrolled');
    }
    else {
      // Trigger this event when scrolled above pixels
      $('.bg-navmenu').removeClass('scrolled');
      $('.bg-navmenu .nav-primary ul li a').removeClass('scrolled');
      $('#fox-logo-full').attr("src" , "/app/uploads/2024/05/fox-face.png");
      $('#fox-logo-full').attr("srcset" , "/app/uploads/2024/05/fox-face.png 1x, /app/uploads/2024/05/fox-face.png 2x");
    }
  });

  if ($(window).width() > 1024) {
    // Mega Menu

    // Check all mega menu's and add to array
    var megaMenuArr = [];
    $('.mega-menu').each(function() {
      var megaMenuName = $(this).data('mega-menu');
      megaMenuArr.push(megaMenuName);
    });

    // Check if menu item has a mega menu linked & show / hide
    $('#header .menu-item').hover(
      function(){
        for ( var i = 0; i < megaMenuArr.length; i++ ) {
          if ( $(this).hasClass(megaMenuArr[i]) ) {
            $('[data-mega-menu="' + megaMenuArr[i] + '"]').show();
            $('.mega-menu-background').show();
            $('.bg-navmenu').addClass('bg-menu-white');
            $('.logo-origin-white').addClass('hidden');
            $('.logo-origin-gold').removeClass('hidden');
            
            break;
          }
        }
      },
      function(){
        $('.mega-menu').hide();
        $('.mega-menu-background').hide();
      }
    );
    $('.mega-menu').hover(
      function(){
        $(this).show();
        $('.mega-menu-background').show();
      },
      function(){
        $(this).hide();
        $('.mega-menu-background').hide();
        $('.bg-navmenu').removeClass('bg-menu-white');
        $('.logo-origin-white').removeClass('hidden');
        $('.logo-origin-gold').addClass('hidden');
      }
    );
  }

  $('.slick-banner').on('init', function () {
    var hiddenSlides = $('.slick-banner .hidden');
    if (hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function (i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  // Slick
  $('.slick-banner').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });
  $('.slick-offer').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 2000,
    infinite: true,
  });

  // Testimonials
  $(".testimonials-carousel").slick({
    dots: true,
    arrows: true,
    fade: true,
    cssEase: "ease-in-out",
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    prevArrow:$('.testi-arrow-p'),
    nextArrow:$('.testi-arrow-n'),
  });

   // gallery-images
   $(".gallery-images-carousel").slick({
    dots: true,
    arrows: true,
    fade: true,
    cssEase: "ease-in-out",
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    prevArrow:$('.gallery-arrow-p'),
    nextArrow:$('.gallery-arrow-n'),
  });

  // Gallery Slider
  $('.slick-gallery-slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    swipeToSlide: true,
    draggable: true,
    centerMode: false,
  });

  $('.certification-acc-slick').slick({
    slidesToShow: 5,
    infinite:true,
    swipeToSlide: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 3,
          infinite:true,
          swipeToSlide: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,        
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          infinite:true,
          swipeToSlide: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,        
        }
      }
    ]
  });

  $('.partner-acc-slick').slick({
    slidesToShow: 5,
    infinite:true,
    swipeToSlide: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 3,
          infinite:true,
          swipeToSlide: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,        
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          infinite:true,
          swipeToSlide: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,        
        }
      }
    ]
  });

  // Slick
  $('.slick-text-images').slick({
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  var $slider = $(".certification-acc-slick");
  var $progressBar = $(".progress");
  var $progressBarLabel = $(".slider__label");

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    $progressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);

    $progressBarLabel.text(calc + "% completed");
  });

  var $slider = $(".partner-acc-slick");
  var $progressBar = $(".progress");
  var $progressBarLabel = $(".slider__label");

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    $progressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);

    $progressBarLabel.text(calc + "% completed");
  });

  $('.slick-p').on('click', function () {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').on('click', function () {
    $(this).parent().prev().slick('slickNext');
  });

  $('.testi-arrow-p').on('click', function () {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.testi-arrow-n').on('click', function () {
    $(this).parent().prev().slick('slickNext');
  });

  $('.gallery-arrow-p').on('click', function () {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.gallery-arrow-n').on('click', function () {
    $(this).parent().prev().slick('slickNext');
  });

  // Mixitup
  if ($('.mix-container').length) {
    var mixer = mixitup('.mix-container');
    if (mixer) {
      console.log('mix');
    }
  }

  if ($('.mix-container-products').length) {
    var mixer = mixitup('.mix-container-products', {
      load: {
        filter: '.product-range-1'
      }
    });
    if (mixer) {
      console.log('mix');
    }
  }

    // Accordion
$('.accordion-item-header').on('click', function(){
  $('.accordion-item').removeClass('active');
  $('.accordion-item-content').slideUp();

  $(this).parent().toggleClass('active');
  $(this).next().slideToggle();
});

  // smooth scroll
   
$(document).on('click', 'a[href^="#"]', function (event) {
  event.preventDefault();
  $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top -130 }, 700);
});

  // Cookie Policy
  $.fn.CookieNotice = function () {
    if (!localStorage.getItem('cookie-notice-dismissed')) {
      var notice = this;
      setTimeout(function () {
        notice.addClass('active');
      }, 1000);
    }
    this.addClass('cookie-notice');
    return this
  }
  $(document).on('click', '.cookie-notice-dismiss', function () {
    localStorage.setItem('cookie-notice-dismissed', true);
    $(this).parents('.cookie-notice').removeClass('active');
  })
  $('#cookie-notice').CookieNotice();

  // Share Button
  $('.page-share').on('click', function () {
    if (navigator.share) {
      navigator.share({
        title: 'Share This Page',
        url: window.location,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
        .catch(err => {
          console.log('Couldnt share because of', err.message);
        });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!')
    }
  });

  $('.panel-share-close').on('click', function () {
    $('#panel-share').removeClass('active');
  });

  // Mobile Nav
  $('#nav-primary-toggle').on('click', function () {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });

  $('.toggle').on('click', function (e) {
    var $this = $(this);
    var $parent = $this.parents('.checkout-step.active');
    $parent.removeClass('active');
    $parent.next().addClass('active');
  });

  // var $document = $(document);
  // $document.scroll(function() {
  //   if ($document.scrollTop() >= 800) {
  //     // user scrolled 50 pixels or more;
  //     // do stuff
  //     $('#fixed-sidebar').addClass(' block');
  //     $('#fixed-sidebar').removeClass("hidden");

  //   } else {
  //     $('#fixed-sidebar').removeClass("block");
  //     $('#fixed-sidebar').addClass(' hidden');

  //   }

  //   if ($(window).width() < 768) {
  //     $('#fixed-sidebar').addClass('hidden');
  //   }
  // });

  // $(".toggler").click(function () {
  //   $(this).parents('#fixed-sidebar').toggleClass('hide');
  // });

  $(document).ready(function () {
    var checkoutSummaryHeight = $('#checkout-summary-fixed').outerHeight();
    $('#checkout-summary-fixed').css('bottom', '-' + checkoutSummaryHeight + 'px');
  });
  $('#checkout-summary-toggle').on('click', function () {
    $(this).toggleClass('active');
    var checkoutSummaryHeight = $('#checkout-summary-fixed').outerHeight();
    var combinedHeight = checkoutSummaryHeight + 53;
    if ($('#checkout-summary-fixed').hasClass('active')) {
      $('#checkout-summary-fixed').css('bottom', '-' + checkoutSummaryHeight + 'px');
      $('#checkout-summary-fixed').removeClass('active')
    } else {
      $('#checkout-summary-fixed').css('bottom', '50px');
      $('#checkout-summary-fixed').addClass('active')
    }
  });

  $('input[name="card_number"]').on('keyup', function () {
    if (this.value.length == this.maxLength) {
      $('input[name="expiry_date"]').focus();
    }
  });

  $('input[name="expiry_date"]').on('keyup', function () {
    if (this.value.length == this.maxLength) {
      $('input[name="cvc"]').focus();
    }
  });

  // Tabbed Producst

  $(".tab-button").on("click", function () {
    var tabButton = $(this).data("tab-button");

    var container = $(this).parent().parent().parent().parent();
    container.find(".tab-button").removeClass("active");
    $(this).addClass("active");

    // Hide all tab contents and images
    container.find("[data-tab-content], [data-tab-image]").hide();

    // Show the selected tab content and image
    container.find('[data-tab-content="' + tabButton + '"]').show();
    container.find('[data-tab-image="' + tabButton + '"]').show();
  });

// brochure tab

$( 'button[data-brochure-target]').click(function(){
  $( 'button[data-brochure-target]').removeClass('active-brochure');
  $(this).toggleClass('active-brochure');
  $('[data-brochure-value').hide();
  var target = $(this).data('brochure-target');
  $('[data-brochure-value="'+target+'"]').show();
})

  // Sticky CTA
  $(window).on('scroll', function () {
    if ($(document).scrollTop() > 300) {
      $('.fixed-side').addClass('fixed-side-show');
    } else {
      $('.fixed-side').removeClass('fixed-side-show');
    }

    if ($(document).scrollTop() > 350) {
      $('.fixed-side').addClass('fixed-desktop');
    } else {
      $('.fixed-side').removeClass('fixed-desktop');
    }
  });

  // Custom chatbot.com triggers
  // If chat has already been started, the load the chatbot.com script - saves loading it if it's not needed
  $(document).on('ready', function () {
    if (localStorage.getItem('chat-initialised') == 'true') {
      var be = document.createElement('script'); be.type = 'text/javascript'; be.async = true;
      be.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.chatbot.com/widget/plugin.js';
      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(be, s);

      window.BE_API = window.BE_API || {};
      window.BE_API.onBeforeLoad = function () {
        return false
      };
    }
  });

  window.__be = window.__be || {};
  window.__be.id = "6440e3ec4a8fcb0007d4e081";
  // Open chat window
  $('.cta-chat-fixed .chat-method-chat').on('click', function () {
    if (localStorage.getItem('chat-initialised') == 'true') {
      window.BE_API = window.BE_API || {};

      if (window.BE_API.isInitialized()) {
        console.log('is initialized');
        window.BE_API.openChatWindow();
      } else {
        window.BE_API.create();
        window.BE_API.onLoad = function () {
          window.BE_API.openChatWindow();
        };
      }
    } else {
      localStorage.setItem('chat-initialised', 'true')
      var be = document.createElement('script'); be.type = 'text/javascript'; be.async = true;
      be.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.chatbot.com/widget/plugin.js';
      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(be, s);

      window.BE_API = window.BE_API || {};
      window.BE_API.openChatWindow();
    }
    $(this).closest('.cta-chat-fixed').addClass('chat-open');
  });

  // Close chat window
  window.BE_API = window.BE_API || {};
  window.BE_API.onChatWindowClose = function () {
    window.BE_API.hideChatWindow();
    $('.cta-chat-fixed').removeClass('chat-open');
  };

  // start of tabbed content

  $('.tabbed-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    infinite: false,
    speed: 400,
    draggable: false,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
  });


  // Custom slick dots
  $('.custom-slick-dot').on('click', function () {
    var dotIndex = $(this).index();
    $('.tabbed-slider').slick('slickGoTo', dotIndex);
  });


  $('.tabbed-slider').on('afterChange', function (event, slick, currentSlide) {

    $('.custom-slick-dot').removeClass('active');


    $('.custom-slick-dot').eq(currentSlide).addClass('active');
  });

  // end of tabbed content


  // colour picker

  $('.swatch-btn').on('click', function () {
    const img = $('.swatch-img');
    const text = $('.swatch-text');
    const src = $(this).data('image')
    const name = $(this).data('name');

    img.attr('src', src)
    text.text(name)
  })



  // downloads

  $(document).on('click', function (e) {
    const container = $('.filters-wrapper');


    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.options').removeClass('active');
    } else {

      $('.options').toggleClass('active');
    }
  });



  $('.options .option').on('click', function () {
    const dataValue = $(this).data('value');
    const dataName = $(this).data('name');

    const showValue = $(this).parent().parent().find('.show-value');
    const singleDownload = $('.single-download');

    showValue.data('value', dataValue)
    showValue.text(dataName)

    $('.search-wrapper input').val('')



    $('.options .option').each((i, item) => $(item).removeClass('active'))
    $(this).addClass('active')


    $(singleDownload).each(function (i, item) {
      const singleDownloadValue = $(item).data('value');

      // support for safari and firefox
      if (!document.startViewTransition) {
        if (dataValue === 'all') {
          $(item).addClass('active')
          return
        }


        $(item).removeClass('active')

        if (singleDownloadValue === dataValue) {
          $(item).addClass('active')
        }
      }



      document.startViewTransition(() => {
        if (dataValue === 'all') {
          $(item).addClass('active')
          return
        }


        $(item).removeClass('active')

        if (singleDownloadValue === dataValue) {
          $(item).addClass('active')
        }
      })


    })
  })

  $('.search-wrapper input').on('focus', function () {
    $(this).parent().find('label').addClass('active')
  })
  $('.search-wrapper input').on('blur', function (e) {
    if (!e.target.value) {
      $(this).parent().find('label').removeClass('active')
    }
  })


  $('.search-wrapper input').on('input', function (e) {

    const search = e.target.value;
    const singleDownload = $('.single-download');

    const currentFilter = $('.show-value').data('value');




    if (search.length > 0 && search.trim()) {



      $(singleDownload).each((i, item) => {

        const name = $(item).data('name');
        const value = $(item).data('value');

        if (currentFilter !== 'all') {
          $(item).removeClass('active')


          if (value === currentFilter && name.includes(search)) {

            $(item).addClass('active')
          }
        } else {
          $(item).removeClass('active')
          if (name.includes(search)) {

            $(item).addClass('active')
          }
        }


      })

    } else {
      $(singleDownload).each((i, item) => {
        if (currentFilter === 'all') {
          $(item).addClass('active')
          return
        }
        if ($(item).data('value') === currentFilter) {
          $(item).addClass('active')
        }
      })

    }


  })

  $("#side-menu-burger").on("click" , function() {
    $("#sidebar-menu").toggleClass("show-menu");
});

// Hup Roof Types Slider

$('.slick-hup-roofs-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 3,
  autoplay: false,
  slidesToScroll: 1,
  swipeToSlide: true,
  draggable: true,
  centerMode: false,
  responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// Hup Wall Slider

$('.slick-hup-wall-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  autoplay: false,
  slidesToScroll: 1,
  swipeToSlide: true,
  draggable: true,
  centerMode: false,
});

//Hup Roof Types

$('[data-image]').click(function () {
  $('[data-image-target]').hide();
  var target = $(this).data('image');

  $('.counttoggle').hide();
  $('.counttoggle', $(this).parent().siblings()).show();
  console.log(target);
  
  // console.log(target);
  $('[data-image-target="' + target + '"]').fadeIn('fast');
})

//Hup Wall Tabs
$('[data-tab]').click(function () {
  $('[data-tab-target]').hide();
  $('[data-tab]').removeClass('tab-active');
  $(this).addClass('tab-active');
  var target = $(this).data('tab');
  $('[data-tab-target="' + target + '"]').fadeIn('fast');
})


// jQuery('.rooftoggle').click(function () {
 
//   jQuery(".itemswrap").hide();
//   jQuery("div[id=" + jQuery(this).attr("item-related") + "]").show();
// })

$('.hup-wall-target-btn').click(function() {
  var targetSlide = $(this).data('slick-slide');
  console.log(targetSlide);
  $('.slick-hup-wall-slider.slick-initialized').slick( 'slickGoTo', targetSlide - 1);
})

$('.link-tab-button').on('click', function () {
  let target = $(this).data('tab');
  $('.iframe-tab').removeClass('active');
  $('.iframe-tab[data-tab='+target+']').addClass('active');
  $('.link-tab-button').removeClass('active');
  $(this).addClass('active');
});

//Quote Form
$('#quote-roof').on('change', function () {
  var quoteOptions =  $('#quote-roof option');
  var quoteColour =  $('#quote-colour');
  var quoteOptgroup =  $('#quote-colour optgroup');
  var glassColourOption =  $('.glassroof-colour');
  var ultraColourOption =  $('.ultraroof-colour');
  var livinColourOption =  $('.livinroof-colour');
  var flatColourOption =  $('.flatroof-colour');
  var guardianColourOption =  $('.guardianroof-colour');
  var stratusLanternColourOption =  $('.stratus-lantern-colour');
  var flatSkyLightColourOption =  $('.flat-skylight-colour');
  var hupText =  $('.hup-wall-text');
  
   
  
  
  $(quoteColour).prop('disabled',  false);

  $(quoteColour).prop("selectedIndex", 0);
  
  var productSelected = $(quoteOptions).is(':selected');

  

  if(productSelected){
    if($(this).val() == 'hup!'){
      $(hupText).removeClass('hidden');
      $(quoteColour).parent().addClass('hidden');
      // $('.form-size-input').removeClass('!md:w-1/2');
      $('.form-size-input').removeClass('md:pl-4');
      $('.form-size-input').addClass('md:!w-full');
      $('.form-size-input').addClass('md:!pl-0');
    } else{
      $(hupText).addClass('hidden');
      $(quoteColour).parent().removeClass('hidden');
      // $('.form-size-input').addClass('!md:w-1/2');
      $('.form-size-input').addClass('md:pl-4');
      $('.form-size-input').removeClass('!w-full');
    }
     
  }

  

  $(quoteOptgroup).each(function() {
    $( this ).addClass( "hidden" );
  });
  $('.ral-colour-input').addClass('hidden');
  $('.form-size-input').addClass('md:w-1/2');
  $('.form-size-input').addClass('md:pl-4');
  if(quoteOptions){
   var quoteThis = $(this).val();
    switch(quoteThis) {
      case 'Glass Roof':
          glassColourOption.removeClass('hidden');
        break;
      case 'Ultraroof':
          ultraColourOption.removeClass('hidden');
        break;
      case 'Livinroof':
        livinColourOption.removeClass('hidden');
      break;
      case 'Flat Roof':
        flatColourOption.removeClass('hidden');
      break;
      case 'Guardian Roof':
          guardianColourOption.removeClass('hidden');
      break;
      case 'Stratus Lantern':
        stratusLanternColourOption.removeClass('hidden');
      break;
      case 'Flat Skylight':
        flatSkyLightColourOption.removeClass('hidden');
      break;
      default:
        // code block
    }
  } 
})

$('.video-overlay').on('click', function(){
  $(this).remove();
  $('.video').get(0).play();
  this.controls = true ;
})

$(".expand-text").on("click", function() {
  if(!$(this).hasClass('expanded')){
  $(this).find(".big-text").find("p:not(:first-of-type)").slideDown();
  $(this).find(".text-center.text-white.mb-4.tracking-wider.font-medium.text-lg").text('View Less')
  $(this).addClass('expanded');
  }else{
  $(this).find(".big-text").find("p:not(:first-of-type)").slideUp();
  $(this).find(".text-center.text-white.mb-4.tracking-wider.font-medium.text-lg").text('View More')
  $(this).removeClass('expanded');
  }
});
})(jQuery);